import React, { useEffect, useState } from "react";
import { setShowSideBar } from "../reducers/common.reducer";
import { useDispatch} from "react-redux";
import { Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import { Link, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectUserData } from "../reducers/user.reducer";

import logo from "../assets/images/Equity Pal.png";
import subIcon from  "../assets/images/Full Stop.png";
import { 
  FiHome, 
  FiTrendingUp, 
  FiRepeat, 
  FiArrowDownCircle, 
  FiArrowUpCircle, 
  FiUsers, 
  FiUser, 
  FiCircle,
  FiBriefcase } from "react-icons/fi";
  import { TfiWallet } from "react-icons/tfi";
  import { MdOutlineDashboard } from "react-icons/md";

// const DashBoardIcon = () => (
//   <svg
//     xmlns="http://www.w3.org/2000/svg"
//     className="h-6 w-6 mr-2"
//     fill="none"
//     viewBox="0 0 24 24"
//     stroke="currentColor"
//   >
//     <path
//       strokeLinecap="round"
//       strokeLinejoin="round"
//       strokeWidth="2"
//       d="M4 6h16M4 12h16M4 18h16"
//     />
//   </svg>
// );
// const HomeIcon = () => (
//   <svg
//     xmlns="http://www.w3.org/2000/svg"
//     width="24"
//     height="24"
//     viewBox="0 0 24 24"
//     style={{ marginRight: "8px" }}
//   >
//     <path
//       fill="currentColor"
//       fillRule="evenodd"
//       d="M11.293 3.293a1 1 0 0 1 1.414 0l6 6l2 2a1 1 0 0 1-1.414 1.414L19 12.414V19a2 2 0 0 1-2 2h-3a1 1 0 0 1-1-1v-3h-2v3a1 1 0 0 1-1 1H7a2 2 0 0 1-2-2v-6.586l-.293.293a1 1 0 0 1-1.414-1.414l2-2z"
//       clipRule="evenodd"
//     />
//   </svg>
// );

// const JobFinderIcon = () => (
//   <svg
//     xmlns="http://www.w3.org/2000/svg"
//     width="24"
//     height="24"
//     viewBox="0 0 32 32"
//     style={{ marginRight: "8px" }}
//   >
//     <path
//       fill="currentColor"
//       d="M21.053 20.8c-1.132-.453-1.584-1.698-1.584-1.698s-.51.282-.51-.51s.51.51 1.02-2.548c0 0 1.413-.397 1.13-3.68h-.34s.85-3.51 0-4.7c-.85-1.188-1.188-1.98-3.057-2.547s-1.188-.454-2.547-.396c-1.36.058-2.492.793-2.492 1.19c0 0-.85.056-1.188.396c-.34.34-.906 1.924-.906 2.32s.283 3.06.566 3.625l-.337.114c-.284 3.283 1.13 3.68 1.13 3.68c.51 3.058 1.02 1.756 1.02 2.548s-.51.51-.51.51s-.452 1.245-1.584 1.698c-1.132.452-7.416 2.886-7.927 3.396c-.512.51-.454 2.888-.454 2.888H29.43s.06-2.377-.452-2.888c-.51-.51-6.795-2.944-7.927-3.396zm-12.47-.172c-.1-.18-.148-.31-.148-.31s-.432.24-.432-.432s.432.432.864-2.16c0 0 1.2-.335.96-3.118h-.29s.144-.59.238-1.334a10.01 10.01 0 0 1 .037-.996l.038-.426c-.02-.492-.107-.94-.312-1.226c-.72-1.007-1.008-1.68-2.59-2.16c-1.584-.48-1.01-.384-2.16-.335c-1.152.05-2.112.672-2.112 1.01c0 0-.72.047-1.008.335c-.27.27-.705 1.462-.757 1.885v.28c.048.654.26 2.45.47 2.873l-.286.096c-.24 2.782.96 3.118.96 3.118c.43 2.59.863 1.488.863 2.16s-.432.43-.432.43s-.383 1.058-1.343 1.44l-.232.092v5.234h.575c-.03-1.278.077-2.927.746-3.594c.357-.355 1.524-.94 6.353-2.862zm22.33-9.056c-.04-.378-.127-.715-.292-.946c-.718-1.008-1.007-1.68-2.59-2.16c-1.583-.48-1.007-.384-2.16-.335c-1.15.05-2.11.672-2.11 1.01c0 0-.72.047-1.008.335c-.27.272-.71 1.472-.758 1.89h.033l.08.914c.02.23.022.435.027.644c.09.666.21 1.35.33 1.59l-.286.095c-.24 2.782.96 3.118.96 3.118c.432 2.59.863 1.488.863 2.16s-.43.43-.43.43s-.054.143-.164.34c4.77 1.9 5.927 2.48 6.28 2.833c.67.668.774 2.316.745 3.595h.48V21.78l-.05-.022c-.96-.383-1.344-1.44-1.344-1.44s-.433.24-.433-.43s.433.43.864-2.16c0 0 .804-.23.963-1.84V14.66c0-.018 0-.033-.003-.05h-.29s.216-.89.293-1.862z"
//     />
//   </svg>
// );

function SidebarContent() {
  // const roleIdMapComponents = {
  //   1: [
  //     "Dashboard",
  //     "Exchange Rate",
  //     "Transfer Type",
  //     "History",
  //     "Agent",
  //     "Job",
  //   ],
  //   2: [
  //     "Dashboard",
  //     "Exchange Rate",
  //     "Transfer Type",
  //     "History",
  //     "Agent",
  //     "Job",
  //   ],
  // };

    const navigation = [
    { id: 1, name: "Dashboard", route: "/dashboard", icon: <MdOutlineDashboard /> },
    { id: 2, name: "My Wallet", route: "/wallet", icon: <TfiWallet /> },
    { id: 3, name: "R.O.I", route: "/roi", icon: <FiTrendingUp /> },
    {
      id: 4,
      name: "Transfer",
      icon: <FiRepeat />,
      submenu: true,
      submenuItems: [
        { name: "Agent Remain", route: "/agent-remain-list" },
        { name: "Transfer", route: "/transfer" },
        { name: "Transfer History", route: "/transfer-history" },
        { name: "User To User", route: "/user-to-user" },
        { name: "Ur to Ur History", route: "/user-to-user-history" },
        { name: "Transaction Types", route: "/transaction-types" },
      ],
    },
    {
      id: 5,
      name: "Income",
      icon: <FiArrowDownCircle />,
      submenu: true,
      submenuItems: [
        { name: "Income", route: "/income" },
        { name: "Income Details", route: "/income-details" },
      ],
    },
    {
      id: 6,
      name: "Expense",
      icon: <FiArrowUpCircle />,
      submenu: true,
      submenuItems: [
        { name: "Expense", route: "/expense" },
        { name: "Expense Details", route: "/expense-details" },
      ],
    },
    {
      id: 7,
      name: "Agent Data",
      submenu: true,
      icon: <FiUsers />,
      submenuItems: [
        { name: "Agent", route: "/agent" },
        // { name: "Profit & Loss", route: "/profit-loss" },
        { name: "Profit & Loss", route: "/profit-loss-entry" },
        // { name: "Result", route: "/result" },
        { name: "Result & Copy", route: "/result-copy" },
      ],
    },
    {
      id: 8,
      name: "User Data",
      icon: <FiUser />,
      submenu: true,
      submenuItems: [
        { name: "User", route: "/user" },
        { name: "Fund Management", route: "/user/fund-management" },
        { name: "Profit Sharing", route: "/user/profit-sharing" },
        { name: "Profit Sharing all", route: "/user/profit-sharing/for-all"},
        // { name: "Profit History", route: "/user/transactions" },

      ],
    },
    {
      id: 9,
      name: "Business",
      icon: <FiBriefcase />,
      submenu: true,
      submenuItems: [
        { name: "Business Type", route: "/business-type" },
      ],
    },
    // commented Trace / Reports section ကိုလည်း react-icons နဲ့ update လုပ်ထားပါတယ် (ကျလာရင် uncomment လုပ်လို့ရအောင်)
  ];

  const [showHide, setShowHide] = useState({});
  const location = useLocation();
  const dispatch = useDispatch();

  const showHideMenu = (name) => {
    setShowHide((prev) => {
      if (prev[name]) {
        return { ...prev, [name]: false };
      } else {
        return { ...prev, [name]: true };
      }
    });
  };

  return (
    <div className="flex flex-col h-full w-full bg-white font-bold font-mono tracking-tighter text-[0.9rem]">
      <div className="flex flex-col flex-1 overflow-y-auto no-scrollbar">
        <nav className="flex flex-col flex-1 overflow-y-auto no-scrollbar bg-white pb-3">

          <div className="flex items-center pl-8 h-12 mt-5">
            <img src={logo} alt="" />
          </div>

          <div key="menu list" className="flex flex-col flex-1 mt-5">
            {navigation.map((el, index) =>
              el.submenu ? (
                <div key={el.id}>
                  <div onClick={() => showHideMenu(el.name)}
                     className={`cursor-pointer px-3 py-3 text-gray-800 hover:bg-gray-300 hover:bg-opacity-25 rounded`}>
                    <div
                      className="ml-4 flex items-center"
                      >
                           <div className="w-8">{el.icon}</div>
                           {el.name}
                     </div>
                   </div>


                  {showHide[el.name] && (
                    <ul className="text-slate-600">
                      {el.submenuItems.map((submenu, index) => (
                        <li key={index} className={`${location.pathname === submenu.route ? "bg-gray-300  bg-opacity-25" : ''} last:mb-0 hover:bg-gray-300 hover:bg-opacity-40`}>
                          <Link
                            to={submenu.route} onClick={() => dispatch(setShowSideBar(false))}
                            className=" rounded w-full flex flex-1 h-[43px] items-center "
                          >
                            <div className="w-8 ml-11">
                              <FiCircle className="w-2 h-2" />
                            </div>
                            <span>{submenu.name}</span>
                          </Link>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              ) : (
                <div className={`${location.pathname === el.route ? "bg-gray-200 " : ''} px-3 py-3 text-gray-800  hover:bg-gray-300 hover:bg-opacity-25 rounded`}>
                    <Link
                    key={index}
                    to={el.route}
                    className="flex flex-1"
                    >
                       <div className=" ml-4 flex items-center">
                          <div className="w-8">{el.icon}</div>
                          {el.name}
                        </div>

                    </Link>
                </div>
              )
            )}
          </div>
        </nav>
      </div>
    </div>
  );
}

export default SidebarContent;
